import { FansUnitedSDK } from 'fansunited-sdk-esm';

// Types
import { FansUnitedSDKOptions } from '../types';

export default ({ apiKey, environment = 'prod', clientId, lang = 'en', idSchema = 'sportal365', authProvider }: FansUnitedSDKOptions) => {
  return FansUnitedSDK({
    apiKey,
    environment,
    clientId,
    lang,
    idSchema,
    authProvider,
  });
};
